import { render, staticRenderFns } from "./fixedmenu.vue?vue&type=template&id=48a73c62"
import script from "./fixedmenu.vue?vue&type=script&lang=js"
export * from "./fixedmenu.vue?vue&type=script&lang=js"
import style0 from "./fixedmenu.vue?vue&type=style&index=0&id=48a73c62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports